<template>
  <div id="app">
    <!-- Header nur anzeigen, wenn die Route nicht Login ist -->
    <Header v-if="showHeader" />
    <main :class="{ 'full-height': !showHeader }">
      <router-view />
    </main>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import Header from "@/components/Header.vue";

export default {
  name: "App",
  components: {
    Header,
  },
  setup() {
    const route = useRoute(); // Zugriff auf die aktuelle Route
    const showHeader = ref(true);
    watch(
      () => route.path, // Beobachte die Route
      (newPath) => {
        const isLoginRoute = newPath === "/"; // Prüfen, ob die aktuelle Route "/"
        showHeader.value = !isLoginRoute;
      },
      { immediate: true } // Überprüfe sofort beim Mounten
    );

    return { showHeader };
  },
};
</script>

<style>
/* Optional: Globales Styling */
body {
  font-family: "DM Sans", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
